export const videoData = [
    {
      videoUrl: 'https://www.youtube.com/embed/wTRS5dkApNM',
      serviceType: 'Bathroom Remodeling',
      location: 'Los Angeles, CA 90069',
      description: 'Bathroom Remodeling in Los Angeles, CA 90069. Stunning transformations combining luxury and functionality.',
      serviceLink: '/projects/bathroom-remodeling-in-los-angeles-ca-90069',
      coverImage: '/videos/bathroom-remodeling-services-in-los-angeles.webp',
    },
    {
      videoUrl: 'https://www.youtube.com/embed/3pDRhHiEteM',
      serviceType: 'Kitchen Remodeling',
      location: 'Hidden Hills, CA 91302',
      description: 'Kitchen Remodeling in Hidden Hills, CA 91302. Modern makeovers that optimize space and style.',
      serviceLink: '/services/kitchen-remodeling',
      coverImage: '/videos/kitchen-remodeling-in-hidden-hills-ca-91302.webp',
    },
    {
      videoUrl: 'https://www.youtube.com/embed/Yqq53bQVY5w',
      serviceType: 'Home Remodeling',
      location: 'Bel Air, CA 90077',
      description: 'Complete Home Remodeling in Bel Air, CA 90077. Comprehensive renovations that elevate every room.',
      serviceLink: '/services/complete-home-remodeling',
      coverImage: '/videos/modern-master-bedroom-remodeling-in-bel-air-los-angeles-90077.webp',
    },
    // Add more videos as needed
  ];